import { ajax } from '../ajax'


//、 授课-课中互动举手列表
export const reqSKInteractList = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/list`, paramets)

//、 授课-课中举手添加
export const reqSKInteractAdd = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/add`, paramets, 'post')

//、 授课-课中举手查询
export const reqSKInteractQuery = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/getActNotFinished`, paramets)

//、 授课-课中举手结束
export const reqSKInteractOver = (paramets) => ajax(`/jxclassroom/jxClassroomActivity/edit`, paramets, 'put')

//、 授课-课中举手结果
export const reqSKInteractRes = (paramets) => ajax(`/jxclassroom/jxClassroomActivityStu/getActStuList`, paramets)

//、 授课-课中举手结果
export const reqSKInteractEdit = (paramets) => ajax(`/jxclassroom/jxClassroomActivityStu/editTeaScore`, paramets, 'put')



// WEBPACK FOOTER //
// ./src/api/give-course/interact.js